module.exports = __webpack_public_path__ + "assets/icon-menu-9c4865a2e185c205e13c7ed2a785f190.svg";